/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use client'

import { createContext, useContext } from 'react'

export interface SideNavContextValue {
  expanded: boolean
  side: 'left' | 'right'
  setExpanded: (expanded: boolean) => void
}

const noopSetExpanded: SideNavContextValue['setExpanded'] = () => {
  // Default context value used outside SideNav.
}

export const SideNavContext = createContext<SideNavContextValue>({
  expanded: true,
  side: 'left',
  setExpanded: noopSetExpanded,
})

export const useSideNavContext = (): SideNavContextValue => useContext(SideNavContext)
